class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
		this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

		this.checkoutButton = this.querySelector('#CartDrawer-Checkout');
		this.boundEventHandler = this.checkout.bind(this);
		this.checkoutButton.addEventListener('click', this.boundEventHandler);
		
		this.setHeaderCartIconAccessibility();
	}
    checkout (e) {

    }

	removeListener() {
		this.checkoutButton.removeEventListener('click', this.boundEventHandler);
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		if (cartLink) {
			cartLink.setAttribute('role', 'button');
			cartLink.setAttribute('aria-haspopup', 'dialog');
			cartLink.addEventListener('click', (event) => {
				event.preventDefault();

				this.open(cartLink);
			});

			cartLink.addEventListener('keydown', (event) => {
				if (event.code.toUpperCase() === 'SPACE') {
					event.preventDefault();
					this.open(cartLink);
				}
			});
		}
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.style.removeProperty("content-visibility");
			this.classList.add('animate', 'active');
		});

		this.addEventListener(
			'transitionend',
			() => {
				const containerToTrapFocusOn = this.classList.contains('is-empty')
				  ? this.querySelector('.drawer__inner-empty')
				  : document.getElementById('CartDrawer');
				const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
			},
			{ once: true }
		);

		document.body.classList.add('overflow-hidden');
	}

	close() {
		this.classList.remove('active');
		document.body.classList.remove('overflow-hidden');
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
		this.querySelector('.drawer__inner').classList.remove('is-empty');

		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
		});

		//grab_cart_and_enforce_promotions();
		if (window.vesyInitializeEventHandlers) {
			window.vesyInitializeEventHandlers();
		}

		setTimeout(() => {
			this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
			this.querySelector('#CartDrawer-Checkout').addEventListener('click', this.boundEventHandler);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
			}
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__inner',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerGWPMeter extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.emptymsg = this.querySelector("[data-meter-message='empty']");
		this.fullmsg = this.querySelector("[data-meter-message='full']");

		this.remaining = this.emptymsg.querySelector("span");
	}

	hideMeter() {
		this.style.setProperty("display", "none");
		this.style.removeProperty("--CartDrawer--gwp_progress", "0%");

		this.emptymsg.style.setProperty("display", "none");
		this.fullmsg.style.setProperty("display", "none");
	}

	showMeterWithValueAndProgress(value, progress) {
		this.style.setProperty("display", "block");

		if (progress >= 100) {
			this.style.setProperty("--CartDrawer--gwp_progress", "100%");

			this.emptymsg.classList.add("d-none");;
			this.fullmsg.classList.remove("d-none");;
		} else {
			this.style.setProperty("--CartDrawer--gwp_progress", progress + "%");
		if (this.remaining) {
			this.remaining.innerText = Shopify.formatMoney(value);
		}

		this.emptymsg.classList.remove("d-none");
		this.fullmsg.classList.add("d-none");
		}
	}
}

customElements.define('cart-drawer-gwp-meter', CartDrawerGWPMeter);

function enforce_promotions(cart, promos) {
	var next_gift_with_purchase = null,
		next_percentage = null,
		eligible_gifts = [],
		gift_already_claimed = false,
		gwp_meter = this.document.querySelector("cart-drawer-gwp-meter"),
		gwp_promo_forms = document.querySelectorAll("[data-cartdrawer-gwp-offer]"),
		swiper_elem = document.querySelector("[data-cartdrawer-gwp-selector-swiper]");

		for (var i = 0; i < gwp_promo_forms.length; i += 1) {
			gwp_promo_forms[i].style.setProperty("display", "none");
		}

		for (i = 0; i < promos.length; i += 1) {
			var non_promotional_value = 0,
				promo_qty = 0,
				target_qty = 0,
				remaining_value = 0;

			for (var j = 0; j < cart.items.length; j += 1) {
				if(cart.items[j].sku != '21745') {
					if (cart.items[j].variant_id !== promos[i].gift_product) {
						non_promotional_value += cart.items[j].final_line_price;
					} else {
						promo_qty += cart.items[j].quantity;
					}
				} 
			}

			if (non_promotional_value >= promos[i].min_value) {
				target_qty = 1;
			}

			remaining_value = promos[i].min_value - non_promotional_value;

			if (next_gift_with_purchase === null || remaining_value < next_gift_with_purchase) {
				next_gift_with_purchase = remaining_value;
				next_percentage = non_promotional_value / promos[i].min_value * 100;
			}

			if (promo_qty < target_qty) {
				eligible_gifts.push(i);
			} else if (promo_qty > target_qty) {
				var instance = document.querySelector("cart-drawer"),
				body = new FormData();
				body.append("id", promos[i].gift_product);
				body.append("quantity", target_qty);
				body.append("sections", instance.getSectionsToRender().map((section) => section.id));

				fetch(window.Shopify.routes.root + "cart/change.js", {
					method: "POST",
					body: body
				}).then(function(resp) {
					if (resp.status === 200) {
						return resp.json();
					}
				}).then(function(resp) {
					instance.renderContents(resp);
				});

				break;
			}

			if (promo_qty >= target_qty && target_qty > 0) {
				gift_already_claimed = true;
			}
		}

		if (gwp_meter) {
			if (next_gift_with_purchase !== null) {
				gwp_meter.showMeterWithValueAndProgress(next_gift_with_purchase, next_percentage);
			} else {
				gwp_meter.hideMeter();
			}
		}
		
		let minValues = Object.keys( CONFIGURED_CART_PROMOS ).map(function ( key ) { return CONFIGURED_CART_PROMOS[key].min_value});
		let minAmountToSpend = Math.min(...minValues);

		if (!gift_already_claimed && eligible_gifts.length > 0 && gwp_meter && cart.items_subtotal_price > minAmountToSpend) {
			document.querySelector("[data-cartdrawer-gwp-selector]").classList.remove('d-none');
			document.querySelector("[data-cartdrawer-gwp-selector] [data-cartdrawer-accordion-link]").click();

			for (var i = 0; i < eligible_gifts.length; i += 1) {
				var j = eligible_gifts[i];
				document.querySelector("[data-cartdrawer-gwp-offer='" + j + "']").style.setProperty("display", "block");
			}
		} else {
			if (document.querySelector("[data-cartdrawer-gwp-selector]")) {
				document.querySelector("[data-cartdrawer-gwp-selector]").classList.add('d-none');
			}
		}

		if (document.querySelector("[data-cartdrawer-gwp-selector] [data-cartdrawer-accordion-link]")) {
			document.querySelector("[data-cartdrawer-gwp-selector] [data-cartdrawer-accordion-link]").classList.toggle("disabled", gift_already_claimed);
		}

		if (swiper_elem) {
			setTimeout(() => {
				swiper_elem = document.querySelector("[data-cartdrawer-gwp-selector-swiper]");
				new Swiper(swiper_elem, {
					speed: 400,
					autoPlay: false,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						renderBullet: function (index, className) {
							return '<span class="' + className + '"></span>';
						},
					}
				});

				swiper_elem.swiper.update();
			}, 500);
			
		}
}
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    setTimeout(() => {
        grab_cart_and_enforce_promotions();
    }, 800);
});
grab_cart_and_enforce_promotions();

function grab_cart_and_enforce_promotions() {
	fetch(window.Shopify.routes.root + "cart.js")
		.then((resp) => {
			return resp.json();
		}).then((cart) => {
				enforce_promotions(cart, CONFIGURED_CART_PROMOS);
				if (document.querySelector('.drawer.is-empty')) {
					document.querySelector('.drawer').classList.remove('is-empty');
				}
		});
}

function add_promo_gift_to_cart(promo) {
	if(CONFIGURED_CART_PROMOS.length === 0){
		return;
	}

	const config = fetchConfig();
	config.headers['X-Requested-With'] = 'XMLHttpRequest';
	delete config.headers['Content-Type'];

	fetch(`${routes.cart_url}`, config)
		.then((resp) => {
			return resp.json();
		})
		.then((cart) => {
			let minValues = Object.keys( CONFIGURED_CART_PROMOS ).map(function ( key ) { return CONFIGURED_CART_PROMOS[key].min_value});
			let minAmountToSpend = Math.min(...minValues);

			if(cart.items_subtotal_price < minAmountToSpend) {
				return;
			} else {
				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				let cart = document.querySelector("cart-drawer");

				const formData = new FormData();
				formData.append("id", promo.gift_product);
				formData.append("quantity", 1);
				formData.append(
					"sections",
					cart.getSectionsToRender().map((section) => section.id)
				);
				formData.append('sections_url', window.location.pathname);

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							return;
						}

						//cart.renderContents(response);

						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'product-form',
							productVariantId: response.id,
							cartData: response,
						});
					})
					.finally(() => {
						if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
					});

			}
		});

}

document.addEventListener("submit", (e) => {
	var form = e.target, promo_id;
	if (form && form.matches("[data-cartdrawer-gwp-offer]")) {
		promo_id = form.dataset.cartdrawerGwpOffer;
		e.preventDefault();
		add_promo_gift_to_cart(CONFIGURED_CART_PROMOS[promo_id]);
	}
});